import { baseContainer } from "@base-provider";
import { userDetailsActions } from "../index";
import { API_PARAM } from "../constants/apiParams";
import { base } from "@base-provider";

export const SYSTEM_MODIFIED_NAME = "SYSTEM";

export default class UserService {
  constructor() {
    this.SYSTEM_MODIFIED_NAME = "SYSTEM";
  }

  async getUserDetails(userName) {
    //check if user exists
    let user = this.getCachedUserDetails(userName);
    if (!user) {
      //first we save username to store
      //this is used to prevent multiple getUserDetails requests for the same user
      //because after we make a server request to get all the details for the user and also update the store
      baseContainer.store.dispatch(
        userDetailsActions.initializeUser({ userName })
      );
      let response = await base.post({
        url: API_PARAM.USER_DETAILS,
        data: { userName },
      });

      // if user is not found, we do not need to update the store
      if (response.data){
        baseContainer.store.dispatch(userDetailsActions.cacheUser(response.data));
      }
      
      user = this.getCachedUserDetails(userName);
    }
    return user;
  }

  getCachedUserDetails(userName) {
    return baseContainer
      .getStoreState()
      .userDetails.users.find(
        (x) => x.userName.toLocaleLowerCase() === userName.toLocaleLowerCase()
      );
  }
}
